<template>
  <div class="back-button-government-home no-highlight-select">
    <button @click="onClick">
      <icon-back />
    </button>
  </div>
</template>

<script>
import IconBack from "../icons/IconBack";
export default {
  name: "BackButtonGovernmentHome",
  components: { IconBack },
  props: {
    backAction: {
      type: Function,
      default: null
    }
  },
  methods: {
    onClick() {
      if (this.backAction != null) {
        this.backAction();
      } else if (window.history.state === null) {
        this.$router.replace("/government");
      } else {
        this.$router.back();
      }
    }
  }
};
</script>

<style scoped>
.back-button-government-home {
  font-size: 1.375rem !important;
}
.back-button-government-home > button {
  z-index: 10;
}
@media screen and (min-width: 768px) {
  .back-button-government-home {
    font-size: 1.53125rem !important;
  }
}
</style>
